import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "../containers/Home";
import Packages from "../containers/Packages";
import Prices from "../containers/Prices";
import Categories from "../containers/Categories";
import Sponsors from "../containers/Sponsors";
import ContactUs from "../containers/ContactUs";
import Summary from "../containers/Routes/Summary";
import Prologo from "../containers/Routes/Prologo";
import Stage1 from "../containers/Routes/Stage1";
import Stage2 from "../containers/Routes/Stage2";
import Stage3 from "../containers/Routes/Stage3";
import Stage4 from "../containers/Routes/Stage4";
import Magazine from "../containers/Magazine";
import Gallery from "../containers/Gallery";
import Results from "../containers/Results";
import RaceRoutes from "../containers/RaceRoutes";
import RaceVideos from "../containers/RaceVideos";

import NotFound from "../containers/NotFound";

const App = () => (
  <BrowserRouter basename="/puntacana">
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/paquetes-y-ascensos" element={<Packages />} />
      <Route exact path="/precios" element={<Prices />} />
      <Route exact path="/categorias-y-premiacion" element={<Categories />} />
      <Route exact path="/patrocinio" element={<Sponsors />} />
      <Route exact path="/contactanos" element={<ContactUs />} />
      <Route exact path="/rutas-y-reglamentacion/resumen" element={<Summary />} />
      <Route exact path="/rutas-y-reglamentacion/prologo" element={<Prologo />} />
      <Route exact path="/rutas-y-reglamentacion/etapa-1" element={<Stage1 />} />
      <Route exact path="/rutas-y-reglamentacion/etapa-2" element={<Stage2 />} />
      <Route exact path="/rutas-y-reglamentacion/etapa-3" element={<Stage3 />} />
      <Route exact path="/rutas-y-reglamentacion/etapa-4" element={<Stage4 />} />
      <Route exact path="/revista" element={<Magazine />} />
      <Route exact path="/galeria/:year/:city/:stage" element={<Gallery />} />
      <Route exact path="/rutas/:city/:slug" element={<RaceRoutes />} />
      <Route exact path="/videos/:slug" element={<RaceVideos />} />
      <Route exact path="/:year/resultados" element={<Results />} />
      <Route element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default App;
